<template>
  <Suspense>
    <router-view />
    <template #fallback>
      <div class="flex h-screen">
        <div class="m-auto text-postmaker">
          <svg
            class="h-10 w-10 animate-pulse"
            fill="currentColor"
            viewBox="0 0 196.21 135.47"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="Layer_2" data-name="Layer 2">
              <path
                class="cls-1"
                d="M196.21,91.8a18.08,18.08,0,0,1-18.08,18.08H50.77L25.19,135.47l1.16-25.59C14.07,111.63-.17,106.06,0,91.8V18.07A18.07,18.07,0,0,1,18.08,0H178.13a18.07,18.07,0,0,1,18.08,18.07Z"
              />
            </g>
          </svg>
        </div>
      </div>
    </template>
  </Suspense>
</template>
